import { expVal } from '@atlassian/jira-feature-experiments';

const isIssueSearchWarningsEnabled = {
	get(): boolean {
		return expVal('jira_issue_search_warnings_banner_nin', 'isEnabled', false);
	},
};

export default isIssueSearchWarningsEnabled;
